// Folio PDF cleanup guard. Core logic lives in assets/folio-staff.js.
(() => {
  if (document.getElementById('folio-pdf-clean-style')) return;
  const style = document.createElement('style');
  style.id = 'folio-pdf-clean-style';
  style.textContent = `
    body.printing .preview-toolbar,
    body.printing .edit-only,
    body.printing .edit-only-input,
    body.printing .add-row-btn,
    body.printing .del-btn,
    body.printing .col-del-w,
    body.printing .items-tbl th:last-child,
    body.printing .items-tbl td:last-child,
    body.printing #printArea button,
    body.printing #printArea [data-html2canvas-ignore="true"] {
      display: none !important;
    }
    body.printing .print-only-text {
      display: block !important;
    }
    body.printing .doc-preview,
    body.printing #printArea,
    body.printing .doc-inner {
      box-shadow: none !important;
      border-radius: 0 !important;
      overflow: visible !important;
    }
    body.printing #printArea input,
    body.printing #printArea textarea {
      border: 0 !important;
      background: transparent !important;
      box-shadow: none !important;
      outline: 0 !important;
      padding: 0 !important;
      color: var(--doc-text, #222) !important;
      font: inherit !important;
      resize: none !important;
      appearance: none !important;
      -webkit-appearance: none !important;
    }
    body.printing #fNotes,
    body.printing .notes-area {
      display: none !important;
    }
    body.printing .bank-box {
      border: 0 !important;
      background: transparent !important;
      padding: 0 !important;
      min-height: 0 !important;
    }
    body.printing .doc-footer-editable {
      color: var(--doc-footer-text, rgba(255,255,255,.5)) !important;
      text-align: center !important;
    }

    /* Paid stamp must print, but its Undo/Mark button must not. */
    body.printing #printArea #folio-paid-wrap,
    body.printing #printArea #folio-paid-wrap.edit-only {
      display: flex !important;
      visibility: visible !important;
      opacity: 1 !important;
    }
    body.printing #printArea #folio-paid-wrap > div {
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      print-color-adjust: exact !important;
      -webkit-print-color-adjust: exact !important;
    }
    body.printing #printArea #folio-paid-wrap button {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
})();
